<!-- XSpan.vue -->
<!--   dfltvw.css has a rule that messes with layouts that use SPAN elements -->
<script setup lang="ts">
    import { ref } from 'vue';

    const emits = defineEmits<{
        click: [evt: MouseEvent],
        mouseover: [evt: MouseEvent],
        mouseout: [evt: MouseEvent],
        keydown: [evt: KeyboardEvent],
        keyup: [evt: KeyboardEvent],
        keypress: [evt: KeyboardEvent]
    }>();

    defineExpose({getBoundingClientRect});

    const spanEle = ref<HTMLElement|undefined>();    

    function getBoundingClientRect(): DOMRect|undefined
    {
        return spanEle.value?.getBoundingClientRect();
    }
</script>
<template>

    <div style="display:inline"
            @click="e => emits('click', e)" 
            @mouseover="e => emits('mouseover', e)"
            @mouseout="e => emits('mouseout', e)"
            @keydown="e => emits('keydown', e)"
            @keyup="e => emits('keyup', e)"
            @keypress="e => emits('keypress', e)"
            ref="spanEle">
        <slot></slot>
    </div>
</template>